import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ArrowButton from '../../../../../../../components/arrow-button';
import { Switch } from '../../../../../../../components/switch';
import { NotificationSenderType, UserPermissionType } from '../../../../../../../data-access/gql-types/graphql';
import { usePreventBack } from '../../../../../../../hooks';
import { useUserPermissions } from '../../../../../../../hooks/user/use-user-permissions';
import { ROUTES } from '../../../../../../../routes/routes';
import { ChannelGateType, ChannelType } from '../../../../../types';

type GateDialogConfigurationProps = {
  pushActive: boolean;
  selectedChannel: ChannelType | null;
  togglePush: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const GateDialogConfiguration: React.FC<GateDialogConfigurationProps> = ({
  pushActive,
  selectedChannel,
  togglePush,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('action');
  const { t: tf } = useTranslation('configuration');
  const { t: tc } = useTranslation('common');
  const { permissions } = useUserPermissions();
  const hasPermissions = permissions[UserPermissionType.ChannelConfiguration];
  const currentPushActive = (selectedChannel?.data as ChannelGateType)?.onEventAction === NotificationSenderType.Push;

  const handleRedirect = () =>
    navigate(
      `${ROUTES.ChannelConfiguration(selectedChannel?.data.type, selectedChannel?.id)}?tab=1&barrier-alert=true`,
    );

  usePreventBack(currentPushActive !== pushActive, tc('willLoseChanges'), {
    btnText: tc('buttons.next'),
    onAction: handleRedirect,
  });

  return (
    <>
      <div className="row-container m-b-24">
        <p className="label">{t('events.push')}</p>
        <Switch checked={pushActive} onChange={togglePush} disabled={!hasPermissions} />
      </div>
      {hasPermissions && <ArrowButton title={tf('barrierAlert.label')} onClick={handleRedirect} small dark />}
    </>
  );
};
